import React from 'react';
import { Redirect } from 'react-router-dom'
import Table from '../components/Table/DetailsTable.js'
import Menu from '../Screens/Menu.js';
import '../assets/css/Order.css';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid'
import axios from 'axios'
import moment from 'moment';
import RegularButton from "../components/CustomButtons/Button.jsx";
import { toast, } from 'react-toastify'
import Compressor from 'compressorjs';
import { accessKeyId, BASE_URL, bucketName, secretAccessKey, region } from '../utils/handleApi.js';

var aws = require('aws-sdk')

const useStyles = (theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1.6),
            marginBottom: theme.spacing(7),
        }, [theme.breakpoints.down('xs')]: {
            marginLeft: "15%"
        },
        flexGrow: 1,
    },
});

//const stripePromise = loadStripe('pk_test_51IKzrPFhMoRgDqY1HXgmYAAhaOQuUFQDvC5aNVOyU37SwODVsimoMSXAn0AZddhNI2WK6nSYaVOZgpWtHydaNp6z00mFGd8HGv');

// const stripePromise = loadStripe(process.env.REACT_APP_PUBLIC_STRIPE_KEY)

const btnStyle = { fontSize: '20px', borderRadius: 1, fontFamily: 'Roboto-Regular', outline: 'none', 
backgroundColor: '#00BCD4', color: 'white', width: '10em', textTransform: 'none', 
verticalAlign: "middle", margin: "0 1em" }

const btnStyle1 = { fontSize: '20px', borderRadius: 1, fontFamily: 'Roboto-Regular', outline: 'none', 
backgroundColor: '#79CDCD', color: 'white', width: '10em', textTransform: 'none', 
verticalAlign: "middle", margin: "0 1em" }

var s3Client = new aws.S3({ accessKeyId, secretAccessKey, region })

class Details extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
          isOpen: false,
          isOnHold: false,
          isCompleted: false,
          // isDialogOpen: false,
          order_details: [],
          response_input: [],
          selectedFile: null,
          selectedFileBlock: ""
        };
        this.loadDoc = React.createRef();
      }

    componentDidMount() {
      const tokenStr = localStorage.getItem('token');
      const options = {
          headers: {
            'Authorization': `Bearer ${tokenStr}` 
          }
      };
      axios.post(`${BASE_URL}/order/orderDetails`, {
          order_id: this.props.match.params.id
      }, options)
      .then((res) => {
          this.setState({ order_details: res.data })
          const { latest_status } = res.data
          switch(latest_status){
            case "Open":
              this.setState({ isOpen: true, isOnHold: false, isCompleted: false });
              break;
            case "Hold":
              this.setState({ isOpen: false, isOnHold: true, isCompleted: false });
              break;
            case "Completed":
              this.setState({ isOpen: false, isOnHold: false, isCompleted: true })
              break;
            default: 
              break;
          }
      })
      .catch(() => {
        toast.error('Some Error Happened in order details')
      })
    }

    updateResponseInput = () => {
      let tokenStr = localStorage.getItem('token')
      const options = {
        headers: {
          'Authorization': `Bearer ${tokenStr}` 
        }
      };
      axios.post(`${BASE_URL}/order/updateResponse`, {
          order_id: this.props.match.params.id,
          order_response : this.state.response_input
        }, options)
        .then(() => {})
        .catch(() => toast.error('Some Error Happened in update response'))
    }

    uploadAttachments = () => {

      // If the uploaded file is image below code will run and call an external function
      var that = this;
      if (!this.state.selectedFile.name.includes('pdf')) {
        // Compresses files only above 5mb
        if(this.state.selectedFile.size > 5000000){
          new Compressor(this.state.selectedFile, {
            quality: 0.4,
            success(result) {
              return that.uploadCompressedImage(result);
            },
            error(err) {
              return toast.error(err.message);
            },
          });
        } else {
          this.uploadCompressedImage(this.state.selectedFile);
        }
      }

      // If the uploaded file is pdf below code will run

      if (this.state.selectedFile.name.includes('pdf')) {
        let uploadParams = {
          Bucket: bucketName,
          Key: this.state.selectedFile.name,
          Body: this.state.selectedFile,
          ContentDisposition: 'inline',
          ContentType: "application/pdf",
          acl: "public"
        }
  
        const s3 = { s3Client, uploadParams, };
  
        s3Client.upload(s3.uploadParams, (err, data) => {
            if (err) {
            } else {
                if (data) {
                  var dictt = {
                      order_id: this.props.match.params.id,
                      lender_id: this.state.lender_id,
                      link: data.Location,
                      "credential_id": localStorage.getItem('vendor_credential_id')
                  }
                  if(this.state.selectedFileBlock === "attachments"){
                    dictt = { ...dictt, attachment_type: "PDF"}
                  } else {
                    dictt = { ...dictt, update_type: "PDF"}
                  }
  
                  let tokenStr = localStorage.getItem('token')
                  const options = {
                      headers: {
                          'Authorization': `Bearer ${tokenStr}` 
                      }
                  };
                  const UPLOAD_URL = `${BASE_URL}/order/`
                  const uploadFor = this.state.selectedFileBlock === "attachments" ? "addAttachments" : "addUpdates"
                  axios.post(`${UPLOAD_URL}${uploadFor}`, dictt, options)
                  .then(() => {
                    this.setState({ selectedFile: null, selectedFileBlock: '' })
                    this.loadDoc.current.loadDocuments();
                  })
                  .catch(() => {
                    toast.error(`Some Error Happened in ${this.state.selectedFileBlock === "attachments" ? "add attachments" : "add updates"}`)
                  })
                }
            }
        })
      }
    }

    uploadCompressedImage = (compressedImage) => {
      let uploadParams = {
          Bucket: bucketName,
          Key: compressedImage.name,
          Body: compressedImage,
          ContentDisposition: 'inline',
          ContentType: "image/png",
          acl: "public"
      }
      const s3 = { s3Client, uploadParams, };
      s3Client.upload(s3.uploadParams, (err, data) => {
          if (err) {
          } else {
              if (data) {
                var dictt = {
                    order_id: this.props.match.params.id,
                    lender_id: this.state.lender_id,
                    link: data.Location,
                    "credential_id": localStorage.getItem('vendor_credential_id')
                }
                if(this.state.selectedFileBlock === "attachments"){
                  dictt = { ...dictt, attachment_type: "Image"}
                } else {
                  dictt = { ...dictt, update_type: "Image"}
                }

                let tokenStr = localStorage.getItem('token')
                const options = {
                    headers: {
                        'Authorization': `Bearer ${tokenStr}` 
                    }
                };
                const UPLOAD_URL = `${BASE_URL}/order/`
                const uploadFor = this.state.selectedFileBlock === "attachments" ? "addAttachments" : "addUpdates"
                axios.post(`${UPLOAD_URL}${uploadFor}`, dictt, options)
                .then(() => {
                  this.setState({ selectedFile: null, selectedFileBlock: '' })
                  this.loadDoc.current.loadDocuments();
                })
                .catch(() => {
                  toast.error(`Some Error Happened in ${this.state.selectedFileBlock === "attachments" ? "add attachments" : "add updates"}`)
                })
              }
          }
      })
    }

    handleHold = (index) => {
      let tokenStr = localStorage.getItem('token')
      const options = {
          headers: {
            'Authorization': `Bearer ${tokenStr}` 
          }
      };

      if(this.state.response_input.length !== 0){
        this.updateResponseInput();
      }

      if(this.state.selectedFile !== null){
        this.uploadAttachments();
      }

      let dict = {
        order_id: this.props.match.params.id,
        status: "Open",
        "credential_id": localStorage.getItem('vendor_credential_id')
      }

      if (index === 1) {
          dict = {
            order_id: this.props.match.params.id,
            status: "Hold",
            "credential_id": localStorage.getItem('vendor_credential_id')
          }
      } 
      
      axios.post(`${BASE_URL}/order/updateStatus`, dict, options)
      .then((res) => {
        if(res.status === 200){
          this.setState({
            isOpen: true, isOnHold: false, isCompleted: false
          })
          if (index === 1) {
            this.setState({
              isOpen: false, isOnHold: true, isCompleted: false
            })
          }
          this.loadDoc.current.loadDocuments();
        }
      })
      .catch((err) => toast.error('Some Error Happened in Holding the order'))
    }

    // On Change of response input
    handleResponseInput = (event, response_input) => {
      event.preventDefault();

      var arrResponses = response_input
      var dict = arrResponses[event.target.getAttribute('data-order')]

      dict["output_data"] = event.target.value
      arrResponses[event.target.getAttribute('data-order')] = dict

      this.setState({ response_input : arrResponses })
    }

    // File attachment
    handleFileChange = (event, lender_id) => {
      this.setState({ selectedFile: event.target.files[0], lender_id, selectedFileBlock: event.target.id });
    }

    // Update transaction directly without payment
    updateStatus = () => {
      const tokenStr = localStorage.getItem('token')
        const options = {
            headers: {
                'Authorization': `Bearer ${tokenStr}` 
            }
        };

      if(this.state.response_input.length !== 0){
        this.updateResponseInput();
      }

      if(this.state.selectedFile !== null){
        this.uploadAttachments();
      }
      
      axios.post(`${BASE_URL}/order/updateStatus`, 
        {
          "order_id": this.state.order_details?.id,
          "lender_id": this.state.order_details?.lender_id?._id,
          "order_no": this.state.order_details?.order_no,
          "status": "Completed",
          "credential_id": localStorage.getItem('vendor_credential_id')
        }, options)
      .then(() => {
        this.setState({ 
          isDialogOpen: false, 
          isCompleted: true,
          isOnHold: false,
          isOpen: false,
        })
      })
      .catch((err) => {
        toast.error('Some Error Happened in update status')
      })
        
      axios.post(`${BASE_URL}/order/makeTransaction`, {
        "order_id": this.state.order_details?.id,
        "lender_id": this.state.order_details?.lender_id?._id,
        "product_id": this.state.order_details?.search_products_type?._id,
        "cost": this.state.order_details?.lender_id?.cost || "10",
        "completed_date": moment().format('MM/DD/YYYY'),
        "credential_id": localStorage.getItem('vendor_credential_id')
      }, options)
        .then(res =>{})
        .catch((err) => toast.error('Some Error Happened in make transaction'))
      }

    render() {
        const { comp_order, look_up } = this.props.location.state;
        if(comp_order === undefined){
          if(look_up === undefined) { 
          return <Redirect to="/Dashboard" />
        }
      }
        return (
          <div style={{ backgroundColor: 'white' }}>
            <Grid container>
                <Grid item>
                    <div>
                      {look_up ? <Menu look_up={look_up} /> : <Menu comp_order={comp_order} /> }
                    </div>
                </Grid>
            </Grid>
            <div className="mdata">
              <Grid container>
                  <Grid item style={{width: "100%"}}>
                    <h2 className="mtextOpenOrder">
                        Details
                    </h2>
                    <div style={{ width: '85vw', marginLeft: 'auto', marginRight: 'auto' }}>
                        <Grid container>
                            <Grid item>
                                <div>
                                    <Table 
                                      orderId={this.props.match.params.id} 
                                      comp_order={comp_order}
                                      handleResponseInput={(event, response_input) => this.handleResponseInput(event, response_input)}
                                      handleFileChange={(event, lender_id) => this.handleFileChange(event, lender_id)}
                                      ref={this.loadDoc}
                                      uploadOrderAttachments={this.uploadAttachments}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </div>

                    <Grid container justify="center">
                        <div className="btn-group" style={{ marginBottom: "3em" }}>
                          <Button 
                            onClick={() => this.props.history.goBack()} 
                            variant="contained" 
                            style={{ fontSize: '20px', borderRadius: 1, fontFamily: 'Roboto-Regular', outline: 'none', color: 'white', backgroundColor: '#999999', 
                            width: '7em', textTransform: 'none', verticalAlign: "middle", margin: "0 1em" }}>
                                Back
                          </Button>
                          {!comp_order && this.state.isOnHold && !this.state.isCompleted && <Button 
                            onClick={() => this.handleHold(0)}
                            variant="contained" 
                            style={btnStyle1}>
                                Save & Unhold
                          </Button>}
                          {!comp_order && this.state.isOpen && !this.state.isCompleted && <Button 
                            onClick={() => this.handleHold(1)}
                            variant="contained" 
                            style={btnStyle}>
                                Save & Hold
                          </Button>}
                          {!comp_order && (this.state.isOpen || this.state.isOnHold) && !this.state.isCompleted && <Button 
                            //onClick={() => this.setState({ isDialogOpen: true })}
                            onClick={this.updateStatus}
                            variant="contained" 
                            style={{ fontSize: '20px', borderRadius: 1, fontFamily: 'Roboto-Regular', 
                            outline: 'none', 
                            color: 'white', backgroundColor: '#04ab23', width: '10em', textTransform: 'none', 
                            verticalAlign: "middle", margin: "0 1em" }}
                          >
                            Complete & Send
                          </Button>}
                          {!comp_order && this.state.isCompleted && <RegularButton 
                            disabled
                            variant="contained" 
                            style={{ fontSize: '20px', borderRadius: 1, fontFamily: 'Roboto-Regular', 
                            outline: 'none', 
                            color: 'white', backgroundColor: '#04ab23', width: '12em', textTransform: 'none', 
                            verticalAlign: "middle", margin: "0 1em" }}
                          >
                            Completed & Sent
                          </RegularButton>}
                    </div>
                    </Grid>
                    {/* <Dialog 
                        open={this.state.isDialogOpen} 
                        onClose={()=> {}} 
                        aria-labelledby="form-dialog-title"
                        fullWidth={true}
                        maxWidth = {'sm'}
                    >
                        <DialogTitle id="form-dialog-title">Add Card Details</DialogTitle>
                        <DialogContent style={{ width: "500px", margin: "auto" }}>
                            <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
                                <CheckoutForm 
                                  order_details={this.state.order_details} 
                                  closeDialog={() => {
                                    this.setState({ 
                                      isDialogOpen: false, 
                                      isCompleted: true,
                                      isOnHold: false,
                                      isOpen: false,
                                     })}} 
                                />
                            </Elements>
                        </DialogContent>
                    </Dialog> */}
                </Grid>

            </Grid>
          </div>
        </div>
      );
    }

}

// const CARD_OPTIONS = {
//     iconStyle: 'solid',
//     style: {
//       base: {
//         iconColor: '#c4f0ff',
//         color: 'green',
//         fontWeight: 500,
//         fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
//         fontSize: '16px',
//         fontSmoothing: 'antialiased',
//         ':-webkit-autofill': {
//           color: '#fce883',
//         },
//         '::placeholder': {
//           color: '#87bbfd',
//         },
//       },
//       invalid: {
//         iconColor: '#ffc7ee',
//         color: '#ffc7ee',
//       },
//     },
//   };
  
// const CardField = ({onChange}) => (
//   <div className="FormRow">
//     <CardElement options={CARD_OPTIONS} onChange={onChange} />
//   </div>
// );
  
//   const Field = ({
//     label,
//     id,
//     type,
//     placeholder,
//     required,
//     autoComplete,
//     value,
//     onChange,
//   }) => (
//     <div className="FormRow">
//       <label htmlFor={id} className="FormRowLabel" style={{ marginRight: "10px", color: "green" }}>
//         {label}
//       </label>
//       <input
//         className="FormRowInput"
//         id={id}
//         type={type}
//         placeholder={placeholder}
//         required={required}
//         autoComplete={autoComplete}
//         value={value}
//         onChange={onChange}
//       />
//     </div>
//   );
  
//   const SubmitButton = ({processing, error, children, disabled}) => (
//     <button
//       className={`SubmitButton ${error ? 'SubmitButton--error' : ''}`}
//       type="submit"
//       disabled={processing || disabled}
//       style={{backgroundColor: "rgb(4, 171, 35)", color: "white", padding: "10px 15px"}} 
//     >
//       {processing ? 'Processing...' : children}
//     </button>
//   );
  
//   const ErrorMessage = ({children}) => (
//     <div className="ErrorMessage" role="alert">
//       <svg width="16" height="16" viewBox="0 0 17 17">
//         <path
//           fill="#FFF"
//           d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
//         />
//         <path
//           fill="#6772e5"
//           d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
//         />
//       </svg>
//       {children}
//     </div>
//   );
  
//   const ELEMENTS_OPTIONS = {
//     fonts: [
//       {
//         cssSrc: 'https://fonts.googleapis.com/css?family=Roboto',
//       },
//     ],
//   };

//   const CheckoutForm = (props) => {
//     const stripe = useStripe();
//     const elements = useElements();
//     const [error, setError] = useState(null);
//     const [cardComplete, setCardComplete] = useState(false);
//     const [processing, setProcessing] = useState(false);
//     const [paymentMethod, setPaymentMethod] = useState(null);
//     const [billingDetails, setBillingDetails] = useState({
//     //   email: '',
//     //   phone: '',
//       name: '',
//     });
  
//     const handleSubmit = async (event) => {
//       event.preventDefault();
  
//       if (!stripe || !elements) {
//         // Stripe.js has not loaded yet. Make sure to disable
//         // form submission until Stripe.js has loaded.
//         return;
//       }
  
//       if (error) {
//         elements.getElement('card').focus();
//         return;
//       }
  
//       if (cardComplete) {
//         setProcessing(true);
//       }
  
//       const payload = await stripe.createPaymentMethod({
//         type: 'card',
//         card: elements.getElement(CardElement),
//         billing_details: billingDetails,
//       });

//    

//       setProcessing(false);

//       if (payload.error) {
//         setError(payload.error);
//       } else {
//         const tokenStr = localStorage.getItem('token')
//         const options = {
//             headers: {
//                 'Authorization': `Bearer ${tokenStr}` 
//             }
//         };

//         axios.post(`${BASE_URL}/order/makeTransaction, 
//           {
//             "order_id":props.order_details?.id,
//             "lender_id":props.order_details?.lender_id?._id,
//             "payment_id": payload.paymentMethod.id,
//              "credential_id": localStorage.getItem('vendor_credential_id')
//           }, options)
//         .then(res => ('res', res))
//         .catch((err) => {
//         
//         })

//         setPaymentMethod(payload.paymentMethod);


//         axios.post(`${BASE_URL}/order/updateStatus, 
//           {
//             "order_id":props.order_details?.id,
//             "lender_id":props.order_details?.lender_id?._id,
//             "order_no":props.order_details?.order_no,
//             "status": "Completed",
//             "credential_id": localStorage.getItem('vendor_credential_id')
//           }, options)
//         .then(res => {
//         
//           props.closeDialog()
//         })
//         .catch((err) => {
//          
//         })
//         //
//       }
//     };
  
//     return paymentMethod ? (
//       <div className="Result">
//         <div className="ResultMessage">
//           Transaction has been successfully completed!
//         </div>
//       </div>
//     ) : (
//       <form className="Form" onSubmit={handleSubmit}>
//         <fieldset className="FormGroup">
//             <Field
//                 label="Card Name"
//                 id="name"
//                 type="text"
//                 required
//                 autoComplete="name"
//                 value={billingDetails.name}
//                 onChange={(e) => {
//                   setBillingDetails({...billingDetails, name: e.target.value});
//             }}
//             />
//         </fieldset>
//         <fieldset className="FormGroup">
//           <CardField
//             onChange={(e) => {
//               setError(e.error);
//               setCardComplete(e.complete);
//             }}
//           />
//         </fieldset>
//         {error && <ErrorMessage>{error.message}</ErrorMessage>}
//         <div style={{textAlign: "center", margin: "2em 0 1em 0"}}>
//             <SubmitButton 
//               type="submit" 
//               processing={processing} 
//               error={error} 
//               disabled={!stripe}
//             >
//               Make Payment
//             </SubmitButton>
//         </div>
//     </form>
//     );
//   };  

export default withStyles(useStyles, { withTheme: true })(Details);